module.exports = __webpack_public_path__ + "band_16.61b3524e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_16.png
// module id = i1/g
// module chunks = 0